import { GET_FREE_TRIAL_STATUS, SET_FREE_TRIAL_STATUS } from './constants'

const initialState = {
  loader: false,
  message: null,
  status: null,
  isValid: null,
  error: null,
  success: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_FREE_TRIAL_STATUS.INITIATE:
    case SET_FREE_TRIAL_STATUS.INITIATE:
      return {
        ...state,
        loader: true,
        success: null,
      }
    case GET_FREE_TRIAL_STATUS.SUCCESS:
      return {
        ...state,
        isValid: action.isValid,
        loader: false,
      }
    case GET_FREE_TRIAL_STATUS.ERROR:
    case SET_FREE_TRIAL_STATUS.ERROR:
      return {
        ...state,
        error: action.error,
        isValid: false,
        loader: false,
        success: false,
      }
    case SET_FREE_TRIAL_STATUS.SUCCESS:
      return {
        ...state,
        success: true,
      }
    default:
      return state
  }
}
